import { Print } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { useParams } from "react-router-dom";
import ToastContext from "../../../services/Context/ToastContext";
import { useContext } from "react";
import API from "../../../services/API";
import useStore from "./useStore";
import { txt } from "../../../services/translation";

export default function TestButton(){

    const {id} = useParams()

    const {setToast} = useContext(ToastContext)

    const {status, setStatus} = useStore()

    const handleClick = () => {

        setStatus('testing')

        API.download(`/courses/${id}/certificate/test.pdf`)
            .catch(e => {
                console.error(e.response?.data)
                setToast({severity: 'error', message: txt('errorOccurred')})
            })
            .finally(() => setStatus('saved'))
    }

    return (
        <LoadingButton 
            startIcon={<Print />} 
            onClick={handleClick}
            loading={status === 'testing'}
            disabled={status !== 'saved'}
            variant='outlined'
        >
            {txt('test')}
        </LoadingButton>
    )
}